// Oike — the fields of Cobros y pagos (central base), as Omni created them (31-10-2026).
// Design and rules: docs/servicios/cobros.md. Table ids: netlify/functions/shared/tables.ts › BILLING_TABLES.
// Every link below is single by design; Airtable still allows several (Omni could not change it), so
// the server refuses more than one (src/charges.js › singleLinkProblem).

export const CHARGE = {
  name: 'Name', origin: 'Charge Origin', payerType: 'Payer Type', stakeholder: 'Stakeholder', account: 'Account',
  accountIsReference: 'Account Is Reference', beneficiary: 'Beneficiary Stakeholder', quote: 'Quote', concept: 'Concept',
  amount: 'Amount', currency: 'Currency', dueOn: 'Due On', installmentKind: 'Installment Kind', planKey: 'Plan Key',
  installmentNumber: 'Installment Number', installmentsTotal: 'Installments Total', status: 'Charge Status',
  requestedAt: 'Requested At', cancelledAt: 'Cancelled At', cancelReason: 'Cancel Reason', replaces: 'Replaces Charge',
  onlineEnabled: 'Online Enabled', checkoutReference: 'Checkout Reference', createdBy: 'Created By', key: 'Charge Key', log: 'Charge Log',
  // fldq438XeBZhfP4L1 (docs/servicios/cobros.md › 14). Only if it were missing, the planned method stays in the log ([medio previsto: …])
  plannedMethod: 'Planned Method',
  applications: 'Applications', // reciprocal
};
export const CHARGE_SINGLE_LINKS = [CHARGE.stakeholder, CHARGE.account, CHARGE.quote, CHARGE.replaces, CHARGE.beneficiary];

export const PAYMENT = {
  name: 'Name', legacyCharge: 'Charge' /* sin uso: never written nor read */, entryType: 'Entry Type', refundOf: 'Refund Of',
  amount: 'Amount', currency: 'Currency', receivedOn: 'Received On', method: 'Method', reference: 'Reference', channel: 'Channel',
  provider: 'Provider', providerPaymentId: 'Provider Payment Id', providerEventAt: 'Provider Event At', status: 'Payment Status',
  confirmedAt: 'Confirmed At', voidedAt: 'Voided At', voidReason: 'Void Reason', receiptNumber: 'Receipt Number',
  receiptIssuedAt: 'Receipt Issued At', receiptSnapshot: 'Receipt Snapshot JSON',
  // fldkZq6SJvY8A6BU2: corrections of an issued receipt, each with its own number and frozen snapshot (receipts.js)
  receiptCorrections: 'Receipt Corrections JSON', recordedBy: 'Recorded By', key: 'Payment Key',
  log: 'Payment Log', payerType: 'Payer Type', payerStakeholder: 'Payer Stakeholder', payerAccount: 'Payer Account',
  refundDocNumber: 'Refund Document Number', refundDocIssuedAt: 'Refund Document Issued At', refundDocSnapshot: 'Refund Document Snapshot JSON',
  integrityIssue: 'Integrity Issue', applications: 'Applications',
};
export const PAYMENT_SINGLE_LINKS = [PAYMENT.legacyCharge, PAYMENT.refundOf, PAYMENT.payerStakeholder, PAYMENT.payerAccount];

export const APPLICATION = {
  name: 'Name', payment: 'Payment', charge: 'Charge', amount: 'Amount Applied', currency: 'Currency', status: 'Application Status',
  appliedAt: 'Applied At', appliedBy: 'Applied By', reversedAt: 'Reversed At', reverseReason: 'Reverse Reason',
  payerMismatchReason: 'Payer Mismatch Reason' /* sin uso: a different payer is always refused */, key: 'Application Key', log: 'Application Log',
};
export const APPLICATION_SINGLE_LINKS = [APPLICATION.payment, APPLICATION.charge];

export const BILLING_SETTINGS = { name: 'Name', settings: 'Settings JSON', updatedAt: 'Updated At', updatedBy: 'Updated By', log: 'Settings Log' };

export const CHARGE_ORIGINS = ['direct', 'quote'];
export const PAYER_TYPES = ['person', 'company'];
export const INSTALLMENT_KINDS = ['full', 'advance', 'installment', 'balance'];
export const CHARGE_STATUSES = ['open', 'cancelled'];
export const PAYMENT_STATUSES = ['pending', 'confirmed', 'failed', 'voided'];
export const APPLICATION_STATUSES = ['active', 'reversed'];
